import React from 'react';
import useAuth from '../hooks/api/useAuth';

export default (WrappedComponent) => {
  return (props) => {
    const { fetch } = useAuth();

    return <WrappedComponent authFetch={fetch} {...props} />;
  };
};
